<div class="row title">
	<h3>Dashboard / Portfolio Data / <span>Add New Segment</span></h3>
</div>


<div class="row justify-content-center internalPageBodyContent">
	<div class="col-md-10 col-md-offset-2 mb-3">
		<!-- <button class="button button_emi" (click)="back()"> BACK TO PORTFOLIO DATA</button> -->
		<div class="alert alert-success text-center mt-2" *ngIf="successMessage">{{successMessage}}</div>
		<div class="alert alert-danger text-center mt-2" *ngIf="errorMessage">{{errorMessage}}</div>
		<div class="card cardStyle">
			<div class="card-content my-2 mx-2">
				<div class="tab-content">
					<div class="tab-pane active">
						<form [formGroup]="createPortfolioForm"
							(ngSubmit)="onSubmit(createPortfolioForm.value); createPortfolioForm.reset();" class="form-horizontal">
							<fieldset formArrayName="portfolio">
								<div class="row" *ngFor="let item of getJobAttributes(createPortfolioForm); let i=index"
									[formGroup]="item">
									<div class="col-sm-6">
										<!-- <button class="button button_emi" (click)="back()"> BACK TO PORTFOLIO DATA</button> -->
										<img (click)="back()" src="../../../../assets/img/arrow_left.svg" style="width: 13px" class="cursor-pointer"/>
									</div>
									
									<div class="col-sm-6">
										<i class="fa fa-minus-circle remove_button"
											(click)="createPortfolioForm.get('portfolio').removeAt(i)"></i>
									</div>
									<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">Segment<span class="astric">*</span></label>
											<!-- <input type="text" class="form-control" [attr.id]="'segment'+i" formControlName="segment"> -->
											<select class="form-control custom-select selectStyle" [attr.id]="'segment'+i" formControlName="segment"
												(change)="firstDropDownChanged($event.target.value,i)">
												<option value="" disabled>Select Segment</option>
												<option value="Home">Home</option>
												<option value="Office">Office</option>
											</select>
										</div>
									</div>
									<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">Space<span class="astric">*</span></label>
											<!--  <input type="text" class="form-control" [attr.id]="'space'+i" formControlName="space"> -->
											<select class="form-control custom-select selectStyle" [attr.id]="'space'+i" formControlName="space"
												(change)="spaceDropDownChanged($event.target.value,i)">
												<option value="" disabled>Select Space</option>
												<option *ngFor="let v of spaces[i]" value="{{v}}">
													{{v}}
												</option>
											</select>
										</div>
									</div>
									<!--                                     <div class="col-md-2 td-actions">
                                          <i class="fa fa-minus-circle pull-right removeIcon mr-2" (click)="createPortfolioForm.get('portfolio').removeAt(i)" style=""></i> -->
									<!-- <button type="button" class="btn" (click)="createPortfolioForm.get('portfolio').removeAt(i)">-</button> -->
									<!--                                     </div> -->


									<div class="col-md-6" [attr.id]="themeFlag[i]" *ngIf="themeFlag[i]">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">Theme<span class="astric">*</span></label>
											<!-- <input type="text" class="form-control" [attr.id]="'theme'+i" formControlName="theme"> -->
											<select class="form-control custom-select selectStyle" [attr.id]="'theme'+i" formControlName="theme"
												(change)="themeDropDownChanged($event.target.value,i)">
												<option value="" disabled>Select Theme</option>
												<option *ngFor="let v of themes[i]" value="{{v}}">
													{{v}}
												</option>
											</select>
										</div>
									</div>

									<div class="col-md-6" [attr.id]="lifestageFlag[i]">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">Lifestage<span class="astric">*</span></label>
											<select class="form-control custom-select selectStyle text-capitalize" [attr.id]="'lifestage'+i"
												formControlName="lifestage">
												<option value="" disabled>Select Lifestage</option>
												<option class="text-capitalize" *ngFor="let v of lifeStage" value="{{v.name}}">
													{{transform(v.name)}}</option>
											</select>
										</div>
									</div>
									<div class="col-md-6" [attr.id]="elementsFlag[i]" *ngIf="elementsFlag[i]">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">Elements</label>
											<select class="form-control custom-select selectStyle" [attr.id]="'element'+i" formControlName="element">
												<option value="" disabled>Select Element</option>
												<option *ngFor="let v of elements[i]" value="{{v}}">{{v}}</option>
											</select>
										</div>
									</div>
									<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">EMI</label>
											<!-- <span class="astric">*</span> -->
											<input type="number" min=0 class="form-control selectStyle1" placeholder="Enter EMI"
												[attr.id]="'price_cents'+i" formControlName="price_cents">
										</div>
									</div>
									<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">Space Area</label>
											<input type="number" min=0 class="form-control selectStyle1" placeholder="Enter Space Area"
												formControlName="space_area">
										</div>
									</div>

									<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">Space Shape<span class="astric">*</span></label>
											<!-- <input type="text" min=0 class="form-control" placeholder="Enter Space Shape" formControlName="space_shape"> -->
											<select class="form-control custom-select selectStyle" [attr.id]="'space_shape'+i" formControlName="space_shape">
												<option value="" disabled>Select Shape</option>
												<option value="rectangle">Rectangle</option>
												<option value="square">Square</option>
												<option value="l_shaped">L Shaped</option>
												<option value="round">Round</option>
												<option value="open">Open</option>
											</select>
										</div>
									</div>


									<div class="col-md-6">
										<div class="form-group label-floating inputStyle">
											<label class="control-label labelStyle">Select Top-Down Image<span class="astric1">(Single Image is
													Allowed)</span></label>
											<input type="file" class="form-control border-0" (change)="onChange($event,i)"
												name="attachment_file" [attr.id]="'attachment_file'+i" formControlName="attachment_file" hidden>
												<div class="col-md-12 uploadStyle">
													<div class="col-md-7 imgStyle">{{this.attachment_file?.name ? this.attachment_file?.name : 'Upload Image'}}</div>
													<div class="col-md-4 uploadBtn">
														<label class="labelStyle2" for="{{'attachment_file'+i}}">Upload</label>
													</div>
												</div>
												<!-- <label for="{{'attachment_file'+i}}">Upload</label> -->
										</div>
										<div id="errormsgblock">
											<small [attr.id]="'errorsize'+i" class="text-danger"></small>
											<small [attr.id]="'errorresolution'+i" class="text-danger"></small>
										</div>
										<!-- <p>Note* - Image dimension should be 1010 <i class="fa fa-times" aria-hidden="true"></i> 583</p> -->
										<ng-container *ngIf="this.attachment_file?.name?.length > 0">
											<div class="col-md-12 previeHeadStyle pl-0">
												<div class="col-8 pl-0">
													<img [src]="singleImg" height="31px" width="31px">
													<span class="ml-2 maxImgStyle">{{this.attachment_file.name}}</span>
													<!-- <span class="ml-2 maxPrevStyle"><a [href]="singleImg" target="_blank" class="maxPrevStyle" style="cursor: pointer;">Preview</a></span> -->
												</div>
												<div class="col-4 cancelStyle">
													<span class="fileSizeStyle">{{attachment_fileSize + "MB"}}</span>
													<span class="ml-2 fileSizeStyle" (click)="onCancelSingleImages()"><i class="fa fa-close" style="color: rgba(0, 0, 0, 0.7); font-size:10px; cursor: pointer;"></i></span>
												</div>
											</div>
										</ng-container>
									</div>
									<!--User Story Title-->
									<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">User Story Title</label>
											<input type="text" class="form-control selectStyle1" placeholder="Enter User Story Title"
												[attr.id]="'user_story_title'+i" formControlName="user_story_title">
										</div>
									</div>

									<!--Secondary Images-->
									<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">Select Other Images<span class="astric1">(Max 5 Images are
													Allowed)</span><span class="astric">*</span></label>
											<input type="file" multiple="" [attr.id]="'attachment_files'+i" class="form-control border-0" (change)="onChangeImage($event,i)"
												name="contents" formControlName="contents" hidden>
												<div class="col-md-12 uploadStyle">
													<div class="col-md-7">
														<!-- <ng-container *ngIf="this.multipleFiles.length > 0">
															<div class="imgStyle" *ngFor="let data of multipleFiles">
																image uploaded
															</div>
														</ng-container> -->
														<ng-container *ngIf="this.multipleFiles.length < 1">
															<div class="imgStyle">
																Upload Image
															</div>
														</ng-container>
													</div>
													<div class="col-md-4 uploadBtn">
														<label class="labelStyle2" for="{{'attachment_files'+i}}">Upload</label>
													</div>
												</div>
										</div>
										<ng-container *ngFor="let urlval of this.images;let i = index">
											<div class="col-md-12 previeHeadStyle pl-0">
												<div class="col-8 pl-0">
													<img [src]="urlval" height="31px" width="31px">
													<span class="ml-2 maxImgStyle">{{imageName[i].name}}</span>
													<!-- <span class="ml-2 maxPrevStyle"><a [href]="urlval" target="_blank" class="maxPrevStyle" style="cursor: pointer;">Preview</a></span> -->
												</div>
												<div class="col-4 cancelStyle">
													<span class="fileSizeStyle">{{imageName[i].size + "MB"}}</span>
													<span class="ml-2 fileSizeStyle" (click)="onCancelMaxImages(i)"><i class="fa fa-close" style="color: rgba(0, 0, 0, 0.7); font-size:10px; cursor: pointer;"></i></span>
												</div>
											</div>
										</ng-container>
									</div>
									<div class="col-md-6">
										<div class="form-group label-floating">
											<p class="labelStyle">Featured</p>
											<div class="d-flex">
												<div class="form-check">
													<input formControlName="is_featured" type="radio" id="exampleRadios1" [value]="'true'">
													<label class="form-check-label pl-0" for="exampleRadios1">
														Yes
													</label>
												</div>
												<div class="form-check pl-5">
													<input formControlName="is_featured" type="radio" id="exampleRadios2" [value]="'false'">
													<label class="form-check-label pl-0" for="exampleRadios2">
														No
													</label>
												</div>
											</div>
										</div>
									</div>
									<!-- <img *ngFor='let url of images'  [src]="url" height="150" width="200px" style="margin: 3px;"> <br/> -->
									<!-- <ng-container *ngFor="let url of imageName"> -->
									<!-- <div class="col-md-12"> -->
										
									<!-- </div> -->
									<!-- </ng-container> -->




									<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">Preset Number</label>
											<input type="text" class="form-control selectStyle1" placeholder="Enter Preset Number"
												formControlName="preset_number">
										</div>
									</div>
									<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">Preset Name<span class="astric">*</span></label>
											<input [attr.id]="'preset_name'+i" type="text" class="form-control selectStyle1"
												placeholder="Enter Preset Name" formControlName="preset_name">
										</div>
									</div>
									<!--Seelct Preset-->
									<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">Select Preset Type</label>
											<select class="form-control custom-select selectStyle" formControlName="preset_type"
												(change)="presetDropDownChanged($event.target.value)">
												<option value="" disabled>Select Preset</option>
												<option value="Basic">Basic</option>
												<option value="Advanced">Advanced</option>
												<option value="Plus">Plus</option>
											</select>
										</div>
									</div>

									<!--Select City-->
									<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle"> Search For City</label>
											<ng-select placeholder="Search For City" class="" formControlName="city_select"
												[ngModel]="city_value" (change)="getscityList($event)" (keyup)="searchCity($event)">
												<ng-option *ngFor="let city of city_list" [value]="city.name">{{
													city.name | titlecase
													}}</ng-option>

											</ng-select>

										</div>
									</div>

									<!-- Select Apartment-->
									<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle"> Search For Apartments</label>
											<ng-select placeholder="Search For Apartment" class="" formControlName="apartment_select"
												(change)='getselectedbuilding($event)' [ngModel]="selectedBuilding"
												(keyup)="searchSociety($event)">
												<ng-option *ngFor='let build of societyList' [value]="build.attributes.unid">
													{{build.attributes.apartment_name}}</ng-option>

											</ng-select>

										</div>
									</div>

									<!--Select Flat size/type-->
									<!-- <ng-container *ngIf="flatsize && city_list && societyList && societyList.length > 0"> -->
										<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">Select Flat Type/ Size</label>
											<select class="form-control custom-select selectStyle" id="" (change)="getselectedbuildingtypes($event)">
												<option [ngValue]="null" disabled>Select Flat-Type</option>
												<option *ngFor="let types of flatsize" [value]="types">
													{{ types }}
												</option>
											</select>
										</div>
									</div>
									<!-- </ng-container> -->

									<!--Select Varient Id-->
									<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">Select Variant Id</label>
											<select class="form-control custom-select selectStyle" id="" (change)="isAllVarient($event)">
												<option [ngValue]="null" disabled>Select Variant</option>
												<option *ngFor="let types of varientId" [value]="types.id">
													{{ types.variant_id }}
												</option>
											</select>
										</div>
									</div>

									<div class="col-md-6">
										<div class="form-group label-floating">
											<!-- <label class="control-label"> Search For BOQ Reference Number</label>
                <ng-select
                placeholder="Search and Select BOQ"
                  class=""
                  formControlName="boq_number"
                  [ngModel]="boq_reference_number_value"
                  (change)="getsBOQnumber($event)"
                  (keyup)="searchBOQ($event)"
                >
                  <ng-option *ngFor="let build of boq_dropdown" [value]="build.reference_number">{{
                    build.reference_number
                  }}</ng-option>
                  
                </ng-select> -->
											<label class="control-label labelStyle"> Search For BOQ Reference Number</label>
											<ng-select placeholder="Search and Select BOQ" class="" formControlName="boq_number"
												[ngModel]="boq_reference_number_value" (change)="getsBOQnumber($event)"
												(keyup)="searchBOQ($event)">
												<ng-option *ngFor="let build of boq_dropdown" [value]="build.reference_number">{{
													build.reference_number
													}}</ng-option>

											</ng-select>

										</div>
									</div>
									<ng-container *ngIf="BOQAmount">
										<div class="col-md-6">
											<div class="form-group label-floating">
												<label class="control-label labelStyle">BOQ Value</label>
												<input type="text" class="form-control selectStyle1" formControlName="boq_value" disabled
													[value]="BOQAmount">
											</div>
										</div>
									</ng-container>

									<!--  <div class="col-md-6">
                                         <div class="form-group label-floating">
                                              <label class="control-label"> Portfolio Data</label>
                                              <textarea  class="form-control" formControlName="portfolio_data" [attr.id]="'portfolio_data'+i" placeholder="Enter Portfolio Data" rows="1"></textarea>
                                          </div>
                                      </div> -->
									<div class="col-md-6">
										<div class="form-group label-floating">
											<label class="control-label labelStyle">Description</label>
											<textarea rows="11" class="form-control selectStyle1" placeholder="Enter Description"
												[attr.id]="'description'+i" formControlName="description"></textarea>
											<!-- <input type="" min=0 class="form-control" placeholder="Enter Price" [attr.id]="'description'+i" formControlName="description">-->
										</div>
									</div>

									<div class="col-md-6">
										<p class="mb-2 labelStyle">Upload Preset File</p>
										<div class="input-group">
										  <input id="fileNamePreset{{i}}"   class="form-control preset-zip-file-upload" readonly (click)="filePicker.click()"  formControlName="design_file"  aria-label="Recipient's username" aria-describedby="basic-addon2">
										  <div class="input-group-append">
											<button class="btn cursor-pointer btn-burgntee px-4 font-weight-bold choose-file-btn" (click)="filePicker.click()" type="button">Choose File</button>
										  </div>
										  <input  #filePicker (change) = "onImagePicked($event , i)" type="file"  accept=".zip,.rar,.7zip" class="form-control-file d-none" >
										</div>
										<span id="presetfileerror{{i}}" class="astric"></span>
									</div>
									<div class="col-md-12">
										<div class="form-group label-floating">
											<ul class="ks-cboxtags" id="myUL">
												<li *ngFor="let item of other_elements[i];let j = index">
													<span>
														<input type="checkbox" id="{{item.attributes.item_name+i+j}}" value="{{item.attributes.id}}"
															(change)="isAllSelected($event,i)">
														<label class="text-capitalize"
															for="{{item.attributes.item_name+i+j}}">{{item.attributes.item_name}}</label>
													</span>
													<!-- <span *ngIf="!leadItemscheckedListNames.includes(item.name.toLowerCase())">
                                                    <input type="checkbox" id="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}"
                                                      (change)="isAllSelected($event)" value="{{item.name}}">
                                                    <label for="{{item.name.split(' ')[0].toLowerCase() + '-' + item.price}}">{{item.name}}</label>
                                                  </span> -->
												</li>
											</ul>
										</div>
									</div>
								</div>


							</fieldset>
							<div class="col-md-12 buttonCol">
								<button type="submit" class="button pull-right submitBtn" [disabled]="createPortfolioForm?.invalid  || disablebutton ||  (this.images.length === 0) ">Submit</button>
								<!-- <p (click)="pushJobAttributes(createPortfolioForm)" class="addIcon addNewStyle px-5 py-4"><span class="btnIconStyle">+</span> Add New</p> -->
							</div>


						</form>
						<!-- <h6 class="mt-3">FormGroup Model (<code>createPortfolioForm.value</code>)</h6>
                              <div><pre><code>{{ createPortfolioForm?.value | json }}</code></pre></div> -->
					</div>
				</div>
			</div>
		</div>
	</div>

</div>


// WEBPACK FOOTER //
// ./src/app/platform/organisation/portfolio/portfolio.component.html